// eslint-disable-next-line
function capitalize (value) {
  /**
   * Преобразует первую букву строки в верхний регистр
   * @param {string} value - входная строка
   * @returns {string} строка с первой заглавной буквой
   */
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`
}

export function executeRequest (prefix, request, { url, data, finalizer, catcher }, { getters, dispatch, commit }) {
  /**
   * Универсальная функция для выполнения API запросов с обработкой состояний
   * @param {string} prefix - префикс для названий мутаций
   * @param {Function} request - функция запроса (sendGetRequest, sendPostRequest и т.д.)
   * @param {Object} params - параметры запроса
   * @param {string} params.url - URL для запроса
   * @param {Object} [params.data] - данные для отправки (опционально)
   * @param {Function} params.finalizer - функция обратного вызова при успехе
   * @param {Function} params.catcher - функция обратного вызова при ошибке
   * @param {Object} context - контекст Vuex
   * @param {Object} context.getters - геттеры Vuex
   * @param {Function} context.dispatch - функция dispatch Vuex
   * @param {Function} context.commit - функция commit Vuex
   */
  const LOADING_END = `SET_${prefix.toUpperCase()}_LOADING_END`
  const SAVE_ERROR = `SAVE_${prefix.toUpperCase()}_ERROR`
  commit(`SET_${prefix.toUpperCase()}_LOADING`)
  const ifinalizer = (data) => {
    commit(LOADING_END)
    finalizer(data)
  }
  const icatcher = (data) => {
    commit(LOADING_END)
    commit(SAVE_ERROR, data)
    catcher(data)
  }
  if (data) request(url, data, ifinalizer, icatcher)
  else request(url, ifinalizer, icatcher)
}
